import { VoiceRecorder } from 'capacitor-voice-recorder';
import { toggleDialog } from '../../store/control/duck';
import store from '../../store';
import { NativeSettings, AndroidSettings, IOSSettings } from 'capacitor-native-settings';
import { Capacitor } from '@capacitor/core';
import * as VoiceRecorderWeb from './voice-recorder-web';
import NativeOrWeb from './index';

export const openRecorderPermissionDialog = async () => {
  store.dispatch(
    toggleDialog('permission', {
      intlId: 'voice-recorder-required-msg',
      onClose: async () => {
        if (Capacitor.isNativePlatform()) {
          await NativeSettings.open({
            optionAndroid: AndroidSettings.VoiceRecorder,
            optionIOS: IOSSettings.App
          });
        }
      }
    })
  );
};

export const startRecordingVoice = async () => {
  const currentStatusResult = await VoiceRecorder.getCurrentStatus();
  const isNativePlatform = NativeOrWeb.isNativePlatform();
  if (currentStatusResult.status === 'RECORDING' || currentStatusResult.status === 'PAUSED') {
    await VoiceRecorder.stopRecording();
  }

  const result = await VoiceRecorder.canDeviceVoiceRecord();
  // console.log({ result });

  if (!result.value) {
    throw new Error('Device does not support voice recording');
  }

  const permissionResult = await VoiceRecorder.hasAudioRecordingPermission();

  if (!permissionResult.value) {
    let requestResult;
    if (isNativePlatform) {
      requestResult = await VoiceRecorder.requestAudioRecordingPermission();
    } else {
      requestResult = await VoiceRecorderWeb.requestWebRecordingPermission();
    }
    // console.log({ requestResult });
    if (!requestResult.value) {
      throw new Error('User did not allow voice recording');
    }
  }

  console.log('voice-recorder.js :: startRecordingVoice');
  if (isNativePlatform) {
    return await VoiceRecorder.startRecording();
  } else {
    console.log('voice-recorder.js :: start web recording');
    return await VoiceRecorderWeb.startWebRecording();
  }
};

export const pauseRecordingVoice = async () => {
  const isNativePlatform = NativeOrWeb.isNativePlatform();
  if (isNativePlatform) {
    return await VoiceRecorder.pauseRecording();
  } else {
    console.log('voice-recorder.js :: pause web recording');
    return await VoiceRecorderWeb.pauseWebRecording();
  }
};

export const resumeRecordingVoice = async () => {
  const isNativePlatform = NativeOrWeb.isNativePlatform();
  if (isNativePlatform) {
    return await VoiceRecorder.resumeRecording();
  } else {
    console.log('voice-recorder.js :: resume web recording');
    return await VoiceRecorderWeb.resumeWebRecording();
  }
};

export const stopRecordingVoice = async () => {
  const isNativePlatform = NativeOrWeb.isNativePlatform();
  if (isNativePlatform) {
    return VoiceRecorder.stopRecording();
  } else {
    console.log('voice-recorder.js :: stop web recording');
    return await VoiceRecorderWeb.stopWebRecording();
  }
};
